<template>
  <div data-name="学习中心">
    <div class="filter-inline-panel cle">
      <el-form :inline="true" :model="filterForm" class="fl">
      </el-form>
      <div class="fr">
        <el-button type="primary" size="mini" @click="add('')" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
      </div>
    </div>
    <el-table :data="list" size="mini" border>
      <el-table-column :prop="lang=='cn'?'name_cn':'name'" align="center" :label="$t('learning_center.name')"></el-table-column>
      <el-table-column :prop="lang=='cn'?'address_cn':'address'" align="center" :label="$t('learning_center.address')"></el-table-column>
      <el-table-column prop="sort" align="center" :label="$t('index.sort')"></el-table-column>
      <!-- <el-table-column prop="course_type" align="center" :label="$t('course_sort.type')">
        <template slot-scope="{row}">
        	<div v-if="row.course_type==0">{{lang=='cn'?'全部':'ALL'}}</div>
        	<div v-else>
				<span v-for="(item,index) in TYPE" v-if="row.course_type==parseInt(item.code)">{{lang=='cn'?item.name_cn:item.name}}</span>
        	</div>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('index.operation')" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
          <el-button size="mini" type="info" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="$t('index.dialog_title')" :close-on-click-modal="false" :visible.sync="editFormVisible" width="900px">
      <el-form label-width="80px" ref="editForm" size="mini" label-position="top" :rules="editFormRules" :model="editForm">
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+$t('learning_center.name')" prop="name_cn">
              <el-input v-model="editForm.name_cn" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+$t('learning_center.name')" prop="name">
              <el-input v-model="editForm.name" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+$t('learning_center.address')" prop="address_cn">
              <el-input v-model="editForm.address_cn" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+$t('learning_center.address')" prop="address">
              <el-input v-model="editForm.address" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('learning_center.is_show')" prop="is_show">
            	<el-switch v-model="editForm.is_show" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.sort')" prop="sort">
              <el-input v-model="editForm.sort" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('learning_center.address_type')" prop="address_type">
				<el-select v-model="editForm.address_type" class="w100" :placeholder="$t('index.select')">
					<el-option :label="lang=='cn'?item.name_cn:item.name" :value="parseInt(item.code)" :key="index" v-for="(item,index) in LEARNING_CENTER_TYPE"></el-option>
				</el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item :label="$t('course_sort.type')" prop="type">
						<el-select v-model="editForm.course_type" class="w100" :placeholder="$t('index.select')">
							<el-option :label="lang=='cn'?'全部':'ALL'" :value="0"></el-option>
							<el-option :label="lang=='cn'?item.name_cn:item.name" :value="parseInt(item.code)" :key="index" v-for="(item,index) in TYPE"></el-option>
						</el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	computed:{
		editFormRules(){
			return {
				name: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('learning_center.name'),
					trigger: 'blur'
				}, ],
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('learning_center.name'),
					trigger: 'blur'
				}, ],
				address: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('learning_center.address'),
					trigger: 'blur'
				}, ],
				address_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('learning_center.address'),
					trigger: 'blur'
				}, ],
			}
		},
	},
	data() {
		return {
			is_co:sessionStorage.getItem('is_co'),
			filterForm: {},
			list: [],
			editForm: {},
			editFormVisible: false,
			pages: {
				page: 1,
				count: 100,
				perpage: 20,
			},
			TYPE:[],
			LEARNING_CENTER_TYPE:[],
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config(){
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code:"TYPE,LEARNING_CENTER_TYPE"
			};
			this_.$post(url, datas).then((res) => {
				this_.TYPE = res.TYPE;
				this_.LEARNING_CENTER_TYPE = res.LEARNING_CENTER_TYPE;
			})
		},
		// 初始化
		init: function () {
			var this_ = this;
			var url = "LearnCentersList"
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res;
				this_.pages.count = res.sum;
			})
		},
		add(data) {
			if (data) {
				this.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this.editForm = {
					name: '',
					name_cn: '',
					sort: '',
					address_type: 0,
					course_type: 0,
					address: '',
					address_cn: '',
					is_show: 0,
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		editSubmit() {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var url = "LearnCentersAction";
					var datas = {
						name: this_.editForm.name,
						name_cn: this_.editForm.name_cn,
						address: this_.editForm.address,
						address_cn: this_.editForm.address_cn,
						sort: this_.editForm.sort,
						address_type: this_.editForm.address_type,
						course_type: this_.editForm.course_type,
						is_show: this_.editForm.is_show,
						country: 'us',
					}
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				}
			})
		},
		del(data) {
			var this_ = this;
			var url = "LearnCentersDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 头像上传
		imageSuccess(res, file) {
			if (res.status == 200) {
				this.image = res.data.savename;
				this.editForm.thumb = res.data.showname;
			} else {
				his_.$message.success(res.message);
			}
		},

		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}

	},
	// 过滤器
	filters: {
	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/learning_center.vue